export class CustomersHttp {
    /**
     * Search for a customer
     * @param q
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async searchForCustomer(q) {
        try {
            return await window.axios.get(`customers/search?q=${q}`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Updates a customer
     * @param customer
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async updateCustomer(customer) {
        try {
            return await window.axios.put(`customers`, customer);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Get all customers
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getAllCustomers() {
        try {
            return await window.axios.get(`customers`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Creates a customer
     * @param customer
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async createCustomer(customer) {
        try {
            return await window.axios.post(`customers`, customer);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Delete a customer
     * @param id
     * @return {Promise<AxiosResponse<any>>}
     */
    static async deleteCustomer(id) {
        try {
            return await window.axios.delete(`customers/${id}`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }
}
